import { render, staticRenderFns } from "./AudienceSettings.vue?vue&type=template&id=39b8df86&scoped=true"
import script from "./AudienceSettings.vue?vue&type=script&lang=js"
export * from "./AudienceSettings.vue?vue&type=script&lang=js"
import style0 from "./AudienceSettings.vue?vue&type=style&index=0&id=39b8df86&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39b8df86",
  null
  
)

export default component.exports